// Turbolinksキャッシュ前にローディング状態をリセット
// `.loading` が付いた要素のみ disabled を解除する。
// 対局記録の送信ボタン（`#match_create_btn.form-actions__submit`）は match_form.js が残得点に応じて disabled/.inactive を
// 動的制御しているため、無条件 disabled 解除はキャッシュ復帰時に視覚的乖離を生む。
$(document).on('turbolinks:before-cache', function() {
  $('.form-submit-button-with-loader.loading, .btn-with-loader.loading')
    .removeClass('loading')
    .prop('disabled', false);
  $('.form-submit-button-with-loader, .btn-with-loader').find('span, i, input[type="submit"], button[type="submit"]').css('color', '');
  // 送信遅延フラグが残ったままキャッシュされると、復帰後の初回送信で描画待ちが効かなくなる
  $('form').each(function() { delete this.dataset.btnLoaderDeferred; });
});

$(document).on('turbolinks:load', function() {
  // ボタン内ローダーの制御（form-submit スコープは submit 側で制御するため除外）
  $('.btn-with-loader').not('[data-loading-scope="form-submit"]').on('click', function() {
    const $btn = $(this);

    // ローディング状態に設定
    $btn.addClass('loading');

    setTimeout(function() {
      $btn.removeClass('loading');
    }, 10000); // 10秒後にリセット
  });

  // フォーム内ボタンのローディング状態の制御
  $('.form-submit-button-with-loader').on('click', function() {
    const $btn = $(this);

    // ローディング状態に設定
    $btn.addClass('loading');

    // ボタンのテキストやアイコンを透過させる
    $btn.find('span').css('color', 'transparent');
    $btn.find('i').css('color', 'transparent');
    $btn.find('input[type="submit"]').css('color', 'transparent');
    $btn.find('button[type="submit"]').css('color', 'transparent');

    setTimeout(function() {
      $btn.removeClass('loading');
    }, 10000); // 10秒後にリセット
  });

  // form submit 経由のローダ制御（opt-in）
  // 確認ダイアログキャンセル / HTML5バリデーション失敗時は submit が発火しないため
  // ローディングが誤点灯しない。click ハンドラで多重送信防止用に disabled も付与。
  //
  // 前提: 本ファイルは packs/application.js で leagues/form_validation.js および
  // leagues/league_form_leave_guard.js より後に require される。そのため submit リスナの
  // 登録順も両者より後になり、(1) JSバリデーションが preventDefault 済みかを判定できる、
  // (2) 離脱ガードが先に defaultPrevented=false を見て bypass フラグを立てられる。
  // require 順を動かす場合は、リーグ編集画面のバリデーションと離脱確認を再確認すること。
  $('form').has('[data-loading-scope="form-submit"]').on('submit.btnLoader', function(e) {
    const form = this;
    // JSバリデーション等が送信を止めた場合はローダを点灯させない
    if (e.isDefaultPrevented()) return;
    // requestSubmit による再送信時はローダ制御済みなのでそのまま通す
    if (form.dataset.btnLoaderDeferred === 'true') return;

    const $btn = $(form).find('[data-loading-scope="form-submit"]').first();
    if ($btn.length === 0) return;
    $btn.addClass('loading').prop('disabled', true);
    setTimeout(function() {
      $btn.removeClass('loading').prop('disabled', false);
      delete form.dataset.btnLoaderDeferred;
    }, 10000);

    // 実機モバイルでは submit 直後にページの描画更新が止まり、ローディング状態が
    // 一度も描画されないまま「直前のフレーム」が残ることがある（テキストとローダーが重なる）。
    // 送信を2フレーム遅らせ、ローディング状態を必ず1度描画させてから送信する。
    // requestSubmit は HTML5 バリデーションと submit イベントを再実行するため、
    // 既存の送信経路（バリデーション・UJS）の挙動は変えない。
    if (typeof form.requestSubmit !== 'function') return;
    e.preventDefault();
    form.dataset.btnLoaderDeferred = 'true';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        form.requestSubmit();
      });
    });
  });
});

// ================================
// ページローディングの表示制御
// ================================
(function() {
  'use strict';

  const DELAY_MS = 200;
  const MAX_DISPLAY_MS = 15000;
  let showTimer = null;

  function getSpinner() { return document.querySelector('.loading-spinner'); }

  function showSpinner() {
    const s = getSpinner();
    if (s) {
      s.classList.add('is-active');
      showTimer = setTimeout(hideSpinner, MAX_DISPLAY_MS);
    }
  }

  function hideSpinner() {
    const s = getSpinner();
    if (s) s.classList.remove('is-active');
    clearTimer();
  }

  function clearTimer() {
    if (showTimer !== null) {
      clearTimeout(showTimer);
      showTimer = null;
    }
  }

  function scheduleShow() {
    clearTimer();
    showTimer = setTimeout(showSpinner, DELAY_MS);
  }

  // Turbolinks経由の遷移
  document.addEventListener('turbolinks:request-start', scheduleShow);
  document.addEventListener('turbolinks:request-end', function() {
    clearTimer();
    showTimer = setTimeout(showSpinner, DELAY_MS);
  });
  document.addEventListener('turbolinks:load', function() { clearTimer(); hideSpinner(); });
  document.addEventListener('turbolinks:before-cache', function() { clearTimer(); hideSpinner(); });

  // フルページリロード（リンククリックで検知）
  // beforeunload中はブラウザが再描画しないため、clickイベントで検知する。
  // Turbolinks管理のリンクはe.defaultPreventedがtrueになるためスキップされ、
  // turbolinks:request-startハンドラが代わりに処理する。
  document.addEventListener('click', function(e) {
    if (e.defaultPrevented) return;
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0 || link.target === '_blank') return;
    // remote: true のリンクは Rails UJS の AJAX なので turbolinks:load が発火せず
    // スピナーが15秒タイムアウトまで残り続ける。AJAXは即座に DOM を差し替えるのでスピナー不要。
    if (link.dataset.remote === 'true') return;
    scheduleShow();
  });

  // data-confirm 付きリンクのキャンセル時、click ハンドラで仕掛けた
  // 200ms の showSpinner タイマーをここで解除する。
  // window.confirm() はメインスレッドをブロックするためダイアログ表示中に
  // タイマーは発火できず、同期の confirm:complete 内で clearTimer すれば
  // タイマー発火前にキャンセルできる。万一ブラウザ実装差などで既に表示されていた
  // 場合に備え、hideSpinner() を呼ぶことで表示済み・未表示のどちらも
  // 1 呼び出しで救える（hideSpinner は内部で clearTimer も呼ぶ）。
  //
  // 前提: 本 IIFE は packs/application.js で Rails.start() より先に評価される。
  // require 順が逆転すると Rails UJS の handleConfirm が click 時に
  // stopEverything を呼び、上の click ハンドラが e.defaultPrevented で早期 return
  // するため scheduleShow() 自体が走らなくなる（バグは解消されるが本ハンドラの
  // 出番も消える）。require 順を動かす場合は挙動を再確認すること。
  //
  // 将来 `confirm` イベントを preventDefault するコードが追加された場合、
  // Rails UJS は confirm:complete を発火しない（rails-ujs.js:387-394）。
  // そのパターンが入った時は `ujs:everythingStopped` も併せて購読する。
  document.addEventListener('confirm:complete', function(e) {
    var answer = e.detail && e.detail[0];
    if (!answer) {
      hideSpinner();
    }
  });

  // bfcache復帰時のスピナー解除
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) { clearTimer(); hideSpinner(); }
  });

  // 外部コードからスピナーを解除するためのカスタムイベント
  document.addEventListener('loading-spinner:cancel', function() {
    clearTimer();
    hideSpinner();
  });
})();